import Jitsi from "./Jitsi";

export default Jitsi
